export const GET_ALL_PROMOTIONS = "GET_ALL_PROMOTIONS";
export const GET_ALL_PROMOTIONS_RESPONSE_SUCCESS =
  "GET_ALL_PROMOTIONS_RESPONSE_SUCCESS";
